import { ERequestStatus } from '../../types/requestStatus';
import { TMainArticlesState } from '../../types/mainArticles';
import { EGetMainArticlesActionType, TMainArticlesActions } from '../../actions/mainArticles';

export const defaultState: TMainArticlesState = {
  status: ERequestStatus.Initial,
  items: [],
};

export const mainArticlesReducer = (state = defaultState, action: TMainArticlesActions) => {
  switch (action.type) {
    case EGetMainArticlesActionType.Loading:
      return { ...state, status: ERequestStatus.Loading };

    case EGetMainArticlesActionType.Succeed:
      return { ...state, items: action.payload, status: ERequestStatus.Succeed };

    case EGetMainArticlesActionType.AppendSucceed:
      return { ...state, items: [...state.items, ...action.payload], status: ERequestStatus.Succeed };

    case EGetMainArticlesActionType.Failed:
      return { ...state, status: ERequestStatus.Failed };

    default:
      return state;
  }
};
